import { React, models, kea, history, resources, selectores, componentToRx, Route } from "app/main/std";
import { UsuarioList } from "./list/list";
import { UsuarioEdit } from "./edit/edit";

export class UsuarioCatalogo extends React.Component {
    render() {
        return (
            <div>
                <Route exact path="/catalogos/Usuario" component={UsuarioList} />
                <Route path="/catalogos/Usuario/:id" component={UsuarioEdit} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/usuarios/index.tsx